export enum CostEnum{
    LOCAL="LOCAL",
    OUTOFSTATION="OUT OF STATION"
}